import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/react';
import { mediaQuery } from '@styles/index';

const SKELETON_GRADIENT = `linear-gradient(
  237.34deg,
  rgba(167, 195, 235, 0.18) 5.23%,
  rgba(255, 255, 255, 0.3) 53.37%
)`;

const shimmerSweep = keyframes`
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
`;

const shimmerBarStyles = css`
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      105deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.75) 48%,
      rgba(255, 255, 255, 0) 96%
    );
    animation: ${shimmerSweep} 1.2s ease-in-out infinite;
    will-change: transform;
  }
`;

const Card = styled.article`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 273px;
  height: 209px;
  padding: 8px;
  border-radius: 8px;
  background: #ffffff;

  ${mediaQuery.uptoMobile} {
    width: 100%;
    height: auto;
    min-height: 209px;
  }
`;

const ContentBlock = styled.div`
  position: relative;
  flex: 1;
  width: 100%;
  height: 193px;
  overflow: hidden;
  border-radius: 4px;
  background: ${SKELETON_GRADIENT};
`;

const TextStack = styled.div`
  position: absolute;
  top: 36px;
  left: 6px;
  display: flex;
  flex-direction: column;
  gap: 13px;
  width: calc(100% - 12px);
  max-width: 239px;
`;

const CategoryBar = styled.span`
  display: block;
  width: 67px;
  height: 13px;
  border-radius: 56px;
  background: rgba(25, 154, 162, 0.17);
  mix-blend-mode: multiply;
  ${shimmerBarStyles}
`;

const TitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  width: 207px;
  max-width: 100%;
`;

const TitleLine = styled.span`
  display: block;
  height: 13px;
  border-radius: 56px;
  background: #e8ebf0;
  mix-blend-mode: multiply;
  ${shimmerBarStyles}

  ${({ $width }) => ($width ? `width: ${$width};` : 'width: 100%;')}
`;

const DescriptionGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

const DescriptionLine = styled.span`
  display: block;
  width: 100%;
  height: 9px;
  border-radius: 56px;
  background: rgba(225, 230, 236, 0.52);
  mix-blend-mode: multiply;
  ${shimmerBarStyles}
`;

const TagsRow = styled.div`
  position: absolute;
  left: 6px;
  bottom: 8px;
  display: flex;
  align-items: center;
  gap: 11px;
`;

const TagBar = styled.span`
  display: block;
  flex-shrink: 0;
  height: 24px;
  border-radius: 4px;
  background: #f2f7fc;
  mix-blend-mode: multiply;
  ${shimmerBarStyles}

  ${({ $width }) => `width: ${$width};`}
`;

const TestSeriesListingTestCardSkeleton = () => (
  <Card aria-hidden>
    <ContentBlock>
      <TextStack>
        <CategoryBar />
        <TitleGroup>
          <TitleLine />
          <TitleLine $width="115px" />
        </TitleGroup>
        <DescriptionGroup>
          <DescriptionLine />
          <DescriptionLine />
        </DescriptionGroup>
      </TextStack>
      <TagsRow>
        <TagBar $width="79.5px" />
        <TagBar $width="79.5px" />
        <TagBar $width="59px" />
      </TagsRow>
    </ContentBlock>
  </Card>
);

export default TestSeriesListingTestCardSkeleton;

export const TEST_SERIES_LISTING_SKELETON_COUNT = 6;
export const TEST_SERIES_LISTING_SKELETON_COUNT_MOBILE = 2;
